import { createReducer } from '@reduxjs/toolkit';
import {
  clearPolicyAction,
  setPolicyLoadErrorAction,
  setPolicyLoadingAction,
  setPolicyUnitAction,
  setPolicyUnitsAction,
} from 'store/actions/time-registration-policy-actions';
import { ITimeRegistrationPolicyState } from 'types/time-registration-policy/ITimeRegistrationPolicy';

const initialState: ITimeRegistrationPolicyState = { units: [], loading: false, loadError: false };

const timeRegistrationPolicyReducer = createReducer(initialState, builder =>
  builder
    .addCase(setPolicyUnitsAction, (state, action) => ({ ...state, units: action.payload }))
    .addCase(setPolicyUnitAction, (state, action) => ({
      ...state,
      units: state.units.map(u => (u.unit === action.payload.unit ? action.payload : u)),
    }))
    .addCase(setPolicyLoadingAction, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(setPolicyLoadErrorAction, (state, action) => ({ ...state, loadError: action.payload }))
    .addCase(clearPolicyAction, () => ({ ...initialState })),
);

export default timeRegistrationPolicyReducer;
